module.exports = __webpack_public_path__ + "static/media/ring.131ca3e6.mp3";